import { MutableRefObject, useRef, PropsWithChildren } from "react";

import { css } from "@compiled/react";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { Adg4Tabs } from "@/components/adg4/tabs/src/tabs";

import { TWCTabs } from "./twc-tab-contents/twc-tabs";

export const HeroTeamworkCollection = ({ children }: PropsWithChildren) => {
    const tabsWrapperRef: MutableRefObject<HTMLDivElement | null> =
        useRef(null);

    return (
        <UFOSegment name="homepage-twc-hero">
            <section id="hero-twc" css={twcHeroStyles}>
                <>
                    {children}
                    <Adg4Tabs>
                        <TWCTabs tabsWrapperRef={tabsWrapperRef} />
                    </Adg4Tabs>
                </>
            </section>
        </UFOSegment>
    );
};

const twcHeroStyles = css({
    overflow: "hidden"
});

HeroTeamworkCollection.displayName = "HeroTeamworkCollection";
